<template>
    <section class="view">
        <v-data-table
                :headers="headers"
                :items="pages.items"
                :options.sync="options"
                :server-items-length="pages.total"
                :loading="loading"
                class="elevation-1"
        >

            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Страницы</v-toolbar-title>
                    <v-divider
                            class="mx-4"
                            inset
                            vertical
                    ></v-divider>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark class="mb-2" @click="$router.push('/admin/pages/new')" >Новая страница</v-btn>
                </v-toolbar>
            </template>


            <template v-slot:item.is_public="{ item }">
                <v-btn icon v-if="item.is_public == 1" @click="disablePage(item.id)">
                    <v-icon color="success">mdi-eye</v-icon>
                </v-btn>
                <v-btn icon v-if="item.is_public == 0" @click="enablePage(item.id)">
                    <v-icon>mdi-eye-off</v-icon>
                </v-btn>
            </template>



            <template v-slot:item.actions="{ item }">
                <v-menu>
                    <template v-slot:activator="{ on, attrs }" >
                        <v-icon
                                class="context-menu"
                                v-bind="attrs"
                                v-on="on"
                        >
                            mdi-dots-vertical
                        </v-icon>
                    </template>

                    <v-list>

                        <v-list-item @click="$router.push('/admin/pages/' + item.id)">
                            <v-list-item-icon><v-icon >mdi-pencil</v-icon></v-list-item-icon>
                            <v-list-item-title>Редактировать</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="$router.push('/admin/pages/' + item.id+'/copy')">
                            <v-list-item-icon><v-icon >mdi-content-copy</v-icon></v-list-item-icon>
                            <v-list-item-title>Копировать</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="deletePage(item.id)" >
                            <v-list-item-icon><v-icon color="red">mdi-delete</v-icon></v-list-item-icon>
                            <v-list-item-title>Удалить</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>

        </v-data-table>
    </section>
</template>

<script>
    import {HTTP} from "../../axios";

    export default {
        name: "ThePages",
        data(){
            return{
                loading: false,
                headers:[
                    {
                        text: 'Адрес',
                        align: 'start',
                        sortable: false,
                        value: 'url',
                    },
                    {
                        text: 'Заголовок',
                        sortable: false,
                        value: 'title',
                    },
                    {
                        text: 'Публикация',
                        sortable: false,
                        value: 'is_public',
                    },
                    {
                        text: '',
                        align: 'right',
                        sortable: false,
                        value: 'actions',
                    },
                ],
                pages: {
                    items: [],
                    total: 0
                },
                options: {
                    itemsPerPage: 10,
                    page: 1
                }
            }
        },
        watch: {
            options: {
                handler () {
                    this.update()
                },
                deep: true,
            },
        },
        methods:{
            update(){
                this.loading = true;
                var data = {}
                if(this.options.itemsPerPage != -1){
                    data.itemsPerPage = this.options.itemsPerPage
                    data.page = this.options.page
                }
                HTTP
                    .get(`pages`, {
                        params: data
                    })
                    .then(r=>{
                        this.pages.items = r.data.pages
                        this.pages.total = r.data.total
                        this.loading = false
                    })
                    .catch(() => {
                        this.pages.items = []
                        this.pages.total = 0
                        this.loading = false
                    })
            },
            enablePage(id){
                const data = {
                    isPublic: 1
                }
                HTTP
                    .put(`pages/${id}`, JSON.stringify(data), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                    .then(() => {
                        this.update()
                    })
            },
            disablePage(id){
                const data = {
                    isPublic: 0
                }
                HTTP
                    .put(`pages/${id}`, JSON.stringify(data), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                    .then(() => {
                        this.update()
                    })
            },
            deletePage(id){
                alert(id)
            }
        },
        mounted() {
            this.update()
        }
    }
</script>

<style scoped>

</style>